import "@fortawesome/fontawesome-pro/css/all.css";
import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "fa",
    values: {
      // FontAwesome's fa-bars is drawn on a 448x512 box, so at 24px its bars
      // land on fractional pixels and anti-alias into soft grey lines. This is
      // MDI's mdi-menu path (24x24 grid, 2px bars on whole pixels) rendered
      // inline as SVG by v-icon, matching the backoffice hamburger.
      menu: "M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z",
    },
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#1976D2",
        secondary: "#424242",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
      },
      dark: {
        primary: "#1565C0",
        secondary: "#1E3A5F",
        accent: "#FF4081",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
        background: "#0D1B2A",
        surface: "#1B263B",
        card: "#263238",
      },
    },
  },
});
